import { ToastStateHandler, UserApi } from '../../../api';
import { EvaluationStatus } from '../../../commonTypes/evaluation/calculate.types';
import { useContainer } from '../../useContainer';

const useHttpApproveOrRejectEvaluationUpdate = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (
        id: string,
        status: EvaluationStatus.UPDATE_APPROVED | EvaluationStatus.SUBMITTED,
        setRefresh: React.Dispatch<React.SetStateAction<number>>
    ) => {
        const { exec, abort } = userApi.approveRejectEvaluationUpdate({
            params: {
                id,
                status,
            },
            onSuccess: () => {
                toastHandler.push(
                    'success',
                    `Evaluation Update ${status === EvaluationStatus.SUBMITTED ? 'Rejection' : 'Approval'}`,
                    `Evaluation update ${status === EvaluationStatus.SUBMITTED ? 'Rejected' : 'Approved'} successfuly`
                );
                setRefresh(prev => prev + 1);
            },
            onError: error => error,
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpApproveOrRejectEvaluationUpdate;
